module.exports = __webpack_public_path__ + "fonts/dmsans-bold-webfont.6fbeee4.woff";